// 投票信息
export const queryConfig = ({ commit }, data) => {
  commit('queryConfig', data);
}

export const voteInfo = ({ commit }, data) => {
  commit('voteInfo', data);
}
export const jwt = ({ commit }, data) => {
  commit('jwt', data);
}
export const voteText = ({ commit }, data) => {
  commit('voteText', data);
}
export const activeTab = ({ commit }, data) => {
  commit('activeTab', data);
}